import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ChecklistView from './components/ChecklistView';
import { useMidnightRefresh } from './hooks/useMidnightRefresh';

function App() {
  // Refresh the page at midnight + 10 seconds to update to the new day's tasks
  useMidnightRefresh();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/checklist" element={<ChecklistView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
